import React from 'react';

const OvalOral = () => (
	<svg width="31" height="28" viewBox="0 0 31 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M4.93712 22.1255C2.71254 19.3492 3.1667 15.2938 5.95032 13.0783L17.1007 4.2038C19.8715 1.9986 23.904 2.4502 26.1183 5.21368C28.3428 7.99002 27.8887 12.0454 25.1051 14.2608L13.9546 23.1354C11.1839 25.3406 7.15141 24.889 4.93712 22.1255Z" fill="#FFF980" stroke="#000000" strokeWidth="0.75"/>
		<path d="M11.5601 8.9061L19.3201 18.5934" stroke="#000000" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);

export default OvalOral;
